import { Route, RouteObject } from "react-router-dom";
import ValidationDashboard from "./components/ValidationDashboard/ValidationDashboard";
import PhotoReadsValidationDashboard from "./components/PhotoReadsValidation/PhotoReadsValidationDashboard";

export interface mxValidationsRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: mxValidationsRoute[];
}

export const mxValidationsRoutes: mxValidationsRoute[] = [
  {
    path: "mx/meter-validation",
    // auth: true,
    element: <ValidationDashboard />,
  },
  {
    path: "mx/meter-validation/photometer-validation/view/:meterRunId",
    // auth: true,
    element: <PhotoReadsValidationDashboard />,
  },
  {
    path: "mx/meter-validation/manual-meter-validation/view/:meterRunId",
    // auth: true,
    element: <PhotoReadsValidationDashboard />,
  },
];
